// Backend status hook: probes which secrets are configured and exposes a
// LIVE / DEGRADED / MOCK level for the Deep Research engine.

import { useEffect, useState } from "react";
import { probeBackend, type BackendStatus } from "@/lib/deep-research/api";

export function useBackendStatus() {
  const [status, setStatus] = useState<BackendStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const s = await probeBackend();
        if (mounted) setStatus(s);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return { status, loading };
}
